import React from 'react';

const profileIcons = {
  password: (
    <svg
      width='12'
      height='14'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.94946 2.70801C8.53812 1.52001 7.40946 0.666681 6.08146 0.666681C4.40612 0.660014 3.04212 2.01201 3.03479 3.68735V3.70068V5.13201'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.622 13.0003H3.528C2.132 13.0003 1 11.8683 1 10.4716V7.61294C1 6.21627 2.132 5.08427 3.528 5.08427H8.622C10.018 5.08427 11.15 6.21627 11.15 7.61294V10.4716C11.15 11.8683 10.018 13.0003 8.622 13.0003Z'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.07503 8.30174V9.78308'
        stroke='#828282'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  weekend: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      fill='none'
      viewBox="0 0 14 15"
    >
      <path fill="#d5d5d5"
        d="M13.61 2.46a1.03 1.03 0 0 0-.76-.32h-1.07v-.8c0-.37-.13-.68-.39-.95a1.3 1.3 0 0 0-.95-.39h-.53c-.37 0-.68.13-.95.39-.26.27-.39.58-.39.95v.8H5.36v-.8c0-.37-.13-.68-.4-.95A1.28 1.28 0 0 0 4.02 0h-.54c-.37 0-.68.13-.94.39-.27.27-.4.58-.4.95v.8H1.07c-.29 0-.54.11-.75.32-.21.21-.32.46-.32.75v10.72c0 .29.11.54.32.75.21.21.46.32.75.32h11.78c.29 0 .55-.11.76-.32.21-.21.32-.46.32-.75V3.21c0-.29-.11-.54-.32-.75zM9.64 1.34c0-.08.03-.14.08-.19a.26.26 0 0 1 .19-.08h.53c.08 0 .15.03.2.08.05.05.07.11.07.19v2.41c0 .08-.02.14-.07.19a.28.28 0 0 1-.2.08h-.53a.26.26 0 0 1-.19-.08.26.26 0 0 1-.08-.19zm-6.43 0c0-.08.03-.14.08-.19a.26.26 0 0 1 .19-.08h.54c.08 0 .14.03.19.08.05.05.08.11.08.19v2.41c0 .08-.03.14-.08.19a.26.26 0 0 1-.19.08h-.54a.26.26 0 0 1-.19-.08.26.26 0 0 1-.08-.19zM1.07 13.93V5.36h11.78v8.57z" />
    </svg>
  ),
  pencil: (
    <svg
      className='icon icon-pencil-black'
      id='icon-pencil'
      viewBox='0 0 15 15'
      width='100%'
      height='100%'
    >
      <path
        d='M8.71 2.34l2.84 2.86-7.21 7.24L1.5 9.58zm5 .69L12.3 4.45 9.45 1.59 10.66.37c.5-.49 1.29-.49 1.78 0l1.27 1.28c.39.38.39 1 0 1.38zM.01 13.6c-.05.24.16.45.39.39l3.17-.77-2.84-2.86z' />
    </svg>
  ),
  cancel: (
    <svg
      className='icon icon-cancel'
      id='icon-cancel'
      viewBox='0 0 15.5 15.5'
      width='100%'
      height='100%'
    >
      <path
        d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z' />
      <path
        strokeMiterlimit='50'
        strokeWidth='.5'
        d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z'
      />
    </svg>
  ),
  check: (
    <svg
      height="100%"
      width="100%"
      id="Capa_1"
      viewBox="0 0 14 14">
      <path d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27 c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0 L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z" />
    </svg>
  ),
  noUser: (
    <svg
      width="300px"
      height="200px"
      viewBox="0 0 600 400"
      version="1.1">
      <g>
        <path d="M293.319,213.531c0,-3.866 -2.974,-6.84 -6.84,-6.84c-64.234,0 -117.763,44.31 -121.629,101.11c-0.297,3.866 2.676,6.84 6.245,7.137c0.297,0 0.297,0 0.595,0c3.568,0 6.542,-2.676 6.84,-6.245c3.271,-49.663 50.852,-88.322 107.949,-88.322c3.866,0 6.84,-2.974 6.84,-6.84Z" />
        <path d="M286.777,193.309c37.173,0 67.506,-30.333 67.506,-67.506c0,-37.173 -30.333,-67.803 -67.506,-67.803c-37.47,0 -67.803,30.333 -67.803,67.803c0,37.47 30.333,67.506 67.803,67.506Zm0,-121.629c29.738,0 54.123,24.385 54.123,54.123c0,29.738 -24.385,54.124 -54.123,54.124c-29.738,0 -54.124,-24.386 -54.124,-54.124c0,-29.738 24.088,-54.123 54.124,-54.123Z" />
        <path d="M360.825,193.309c-41.039,0 -74.346,33.307 -74.346,74.345c0,41.039 33.307,74.346 74.346,74.346c41.039,0 74.345,-33.307 74.345,-74.346c0,-41.038 -33.306,-74.345 -74.345,-74.345Zm0,135.309c-33.604,0 -60.963,-27.359 -60.963,-60.964c0,-33.604 27.359,-60.963 60.963,-60.963c33.604,0 60.963,27.359 60.963,60.963c0,33.605 -27.359,60.964 -60.963,60.964Z" />
        <path d="M387.887,261.112l-20.222,0l0,-20.222c0,-3.866 -2.974,-6.84 -6.84,-6.84c-3.866,0 -6.84,2.974 -6.84,6.84l0,20.222l-20.222,0c-3.866,0 -6.84,2.974 -6.84,6.84c0,3.866 2.974,6.84 6.84,6.84l20.222,0l0,20.222c0,3.866 2.974,6.839 6.84,6.839c3.866,0 6.84,-2.973 6.84,-6.839l0,-20.52l20.222,0c3.866,0 6.839,-2.974 6.839,-6.84c0,-3.866 -2.973,-6.542 -6.839,-6.542Z" /></g>
    </svg>
  ),
  family: (
    <svg fill="#000000" version="1.1" id="Capa_1"
      width="800px" height="800px" viewBox="0 0 98.666 98.666">
      <g>
        <g>
          <circle cx="49.332" cy="53.557" r="10.297" />
          <path d="M53.7,64.556h-8.737c-7.269,0-13.183,5.916-13.183,13.184v10.688l0.027,0.166l0.735,0.229
			c6.937,2.168,12.965,2.892,17.927,2.892c9.688,0,15.303-2.764,15.65-2.938l0.688-0.351l0.071,0.002V77.739
			C66.883,70.472,60.971,64.556,53.7,64.556z"/>
          <circle cx="28.312" cy="23.563" r="16.611" />
          <path d="M70.35,40.174c9.174,0,16.609-7.44,16.609-16.613c0-9.17-7.438-16.609-16.609-16.609c-9.176,0-16.61,7.437-16.61,16.609
			S61.174,40.174,70.35,40.174z"/>
          <path d="M41.258,62.936c-2.637-2.274-4.314-5.632-4.314-9.378c0-4.594,2.519-8.604,6.243-10.743
			c-2.425-0.965-5.061-1.511-7.826-1.511H21.266C9.54,41.303,0,50.847,0,62.571v17.241l0.043,0.269L1.23,80.45
			c10.982,3.432,20.542,4.613,28.458,4.656v-7.367C29.688,70.595,34.623,64.599,41.258,62.936z"/>
          <path d="M77.398,41.303H63.305c-2.765,0-5.398,0.546-7.824,1.511c3.727,2.139,6.246,6.147,6.246,10.743
			c0,3.744-1.678,7.102-4.313,9.376c2.656,0.661,5.101,2.02,7.088,4.008c2.888,2.89,4.479,6.726,4.478,10.8v7.365
			c7.916-0.043,17.477-1.225,28.457-4.656l1.187-0.369l0.044-0.269V62.571C98.664,50.847,89.124,41.303,77.398,41.303z"/>
        </g>
      </g>
    </svg>
  ),
  location: (
    <svg height="800px" width="800px" version="1.1"
      viewBox="0 0 293.334 293.334">
      <g>
        <g>
          <path
            d="M146.667,0C94.903,0,52.946,41.957,52.946,93.721c0,22.322,7.849,42.789,20.891,58.878
			c4.204,5.178,11.237,13.331,14.903,18.906c21.109,32.069,48.19,78.643,56.082,116.864c1.354,6.527,2.986,6.641,4.743,0.212
			c5.629-20.609,20.228-65.639,50.377-112.757c3.595-5.619,10.884-13.483,15.409-18.379c6.554-7.098,12.009-15.224,16.154-24.084
			c5.651-12.086,8.882-25.466,8.882-39.629C240.387,41.962,198.43,0,146.667,0z M146.667,144.358
			c-28.892,0-52.313-23.421-52.313-52.313c0-28.887,23.421-52.307,52.313-52.307s52.313,23.421,52.313,52.307
			C198.98,120.938,175.559,144.358,146.667,144.358z"/>
          <circle cx="146.667" cy="90.196" r="21.756" />
        </g>
      </g>
    </svg>
  ),
  birthday: (
    <svg fill="#000000" version="1.1"
      width="800px" height="800px" viewBox="0 0 610.398 610.398">
      <g>
        <g>
          <path d="M159.567,0h-15.329c-1.956,0-3.811,0.411-5.608,0.995c-8.979,2.912-15.616,12.498-15.616,23.997v10.552v27.009v14.052
			c0,2.611,0.435,5.078,1.066,7.44c2.702,10.146,10.653,17.552,20.158,17.552h15.329c11.724,0,21.224-11.188,21.224-24.992V62.553
			V35.544V24.992C180.791,11.188,171.291,0,159.567,0z"/>
          <path d="M461.288,0h-15.329c-11.724,0-21.224,11.188-21.224,24.992v10.552v27.009v14.052c0,13.804,9.5,24.992,21.224,24.992
			h15.329c11.724,0,21.224-11.188,21.224-24.992V62.553V35.544V24.992C482.507,11.188,473.007,0,461.288,0z"/>
          <path d="M539.586,62.553h-37.954v14.052c0,24.327-18.102,44.117-40.349,44.117h-15.329c-22.247,0-40.349-19.79-40.349-44.117
			V62.553H199.916v14.052c0,24.327-18.102,44.117-40.349,44.117h-15.329c-22.248,0-40.349-19.79-40.349-44.117V62.553H70.818
			c-21.066,0-38.15,16.017-38.15,35.764v476.318c0,19.784,17.083,35.764,38.15,35.764h468.763c21.085,0,38.149-15.984,38.149-35.764
			V98.322C577.735,78.575,560.671,62.553,539.586,62.553z M527.757,557.9l-446.502-0.172V173.717h446.502V557.9z"/>
          <path d="M353.017,266.258h117.428c10.193,0,18.437-10.179,18.437-22.759s-8.248-22.759-18.437-22.759H353.017
			c-10.193,0-18.437,10.179-18.437,22.759C334.58,256.074,342.823,266.258,353.017,266.258z"/>
          <path d="M353.017,348.467h117.428c10.193,0,18.437-10.179,18.437-22.759c0-12.579-8.248-22.758-18.437-22.758H353.017
			c-10.193,0-18.437,10.179-18.437,22.758C334.58,338.288,342.823,348.467,353.017,348.467z"/>
          <path d="M353.017,430.676h117.428c10.193,0,18.437-10.18,18.437-22.759s-8.248-22.759-18.437-22.759H353.017
			c-10.193,0-18.437,10.18-18.437,22.759S342.823,430.676,353.017,430.676z"/>
          <path d="M353.017,512.89h117.428c10.193,0,18.437-10.18,18.437-22.759c0-12.58-8.248-22.759-18.437-22.759H353.017
			c-10.193,0-18.437,10.179-18.437,22.759C334.58,502.71,342.823,512.89,353.017,512.89z"/>
          <path d="M145.032,266.258H262.46c10.193,0,18.436-10.179,18.436-22.759s-8.248-22.759-18.436-22.759H145.032
			c-10.194,0-18.437,10.179-18.437,22.759C126.596,256.074,134.838,266.258,145.032,266.258z"/>
          <path d="M145.032,348.467H262.46c10.193,0,18.436-10.179,18.436-22.759c0-12.579-8.248-22.758-18.436-22.758H145.032
			c-10.194,0-18.437,10.179-18.437,22.758C126.596,338.288,134.838,348.467,145.032,348.467z"/>
          <path d="M145.032,430.676H262.46c10.193,0,18.436-10.18,18.436-22.759s-8.248-22.759-18.436-22.759H145.032
			c-10.194,0-18.437,10.18-18.437,22.759S134.838,430.676,145.032,430.676z"/>
          <path d="M145.032,512.89H262.46c10.193,0,18.436-10.18,18.436-22.759c0-12.58-8.248-22.759-18.436-22.759H145.032
			c-10.194,0-18.437,10.179-18.437,22.759C126.596,502.71,134.838,512.89,145.032,512.89z"/>
        </g>
      </g>
    </svg>
  ),
  hobby: (
    <svg fill="#000000" version="1.1"
      width="800px" height="800px" viewBox="0 0 33.428 33.428">
      <g>
        <path d="M32.966,21.154c0,3.488-2.838,6.328-6.328,6.328c-0.549,0-1.096-0.074-1.625-0.215v5.16c0,0.553-0.447,1-1,1h-6.557
		c-0.35,0-0.674-0.183-0.855-0.482c-0.183-0.299-0.192-0.67-0.03-0.979c0.328-0.627,0.495-1.303,0.495-2.007
		c0-2.389-1.94-4.328-4.327-4.328c-2.388,0-4.33,1.939-4.33,4.328c0,0.648,0.144,1.275,0.424,1.859
		c0.129,0.17,0.207,0.381,0.207,0.61c0,0.552-0.447,1-1,1c-0.004,0.001-0.012,0-0.021,0H1.462c-0.553,0-1-0.448-1-1V9.881
		c0-0.552,0.447-1,1-1h5.951C7.059,8.083,6.872,7.215,6.872,6.327C6.872,2.839,9.712,0,13.2,0c3.489,0,6.329,2.839,6.329,6.327
		c0,0.888-0.188,1.756-0.539,2.554h5.021c0.553,0,1,0.448,1,1v5.16c0.529-0.142,1.076-0.215,1.625-0.215
		C30.128,14.826,32.966,17.666,32.966,21.154z"/>
      </g>
    </svg>
  ),
  pets: (
    <svg fill="#000000" width="800px" height="800px" viewBox="0 0 256 256">
      <path d="M136,60a28,28,0,1,1,28,28A28.03146,28.03146,0,0,1,136,60ZM72,108a28,28,0,1,0-28,28A28.03146,28.03146,0,0,0,72,108ZM92,88A28,28,0,1,0,64,60,28.03146,28.03146,0,0,0,92,88Zm95.0918,60.84473a35.3317,35.3317,0,0,1-16.8418-21.124,43.99839,43.99839,0,0,0-84.5-.00439,35.2806,35.2806,0,0,1-16.7998,21.105,40.00718,40.00718,0,0,0,34.57226,72.05176,64.08634,64.08634,0,0,1,48.86524-.03711,40.0067,40.0067,0,0,0,34.7041-71.99121ZM212,80a28,28,0,1,0,28,28A28.03146,28.03146,0,0,0,212,80Z" />
    </svg>
  ),
  gifts: (
    <svg fill="#000000" version="1.1"
      width="800px" height="800px" viewBox="0 0 490.643 490.642">
      <g>
        <g>
          <rect x="68.092" y="260.954" width="357.293" height="229.688" />
          <path d="M213.236,133.348h67.009c17.52-5.578,33.498-15.381,46.747-29.071C345.5,85.15,365.67,45.587,352.66,19.014
			c-5.702-11.646-20.298-22.989-34.17-17.661c-15.557,5.975-25.748,18.712-36.185,31.243c-13.944,16.75-25.685,34.964-35.566,54.198
			c-9.882-19.234-21.622-37.448-35.568-54.198c-10.433-12.531-20.624-25.269-36.183-31.243c-13.875-5.328-28.47,6.015-34.169,17.661
			c-13.01,26.573,7.16,66.136,25.668,85.263C179.738,117.967,195.714,127.771,213.236,133.348z M287.331,73.133
			c5.518-8.459,11.666-16.453,18.124-24.208c3.097-3.72,6.379-7.282,9.658-10.84c3.811-4.134,11.725-14.408,12.748-2.518
			c1.6,18.596-11.665,39.089-23.891,51.723c-9.905,10.236-22.6,16.88-36.175,20.323C273.534,95.729,280.078,84.26,287.331,73.133z
			 M165.613,35.569c1.021-11.89,8.938-1.619,12.749,2.518c3.281,3.559,6.562,7.12,9.659,10.84
			c6.457,7.756,12.607,15.75,18.123,24.208c7.254,11.125,13.798,22.594,19.535,34.479c-13.575-3.442-26.27-10.086-36.175-20.323
			C177.282,74.658,164.017,54.162,165.613,35.569z"/>
          <polygon points="448.071,147.527 42.571,147.527 42.571,246.775 68.092,246.775 425.386,246.775 448.071,246.775 		" />
        </g>
      </g>
    </svg>
  ),
  friends: (
    <svg fill="#000000" width="800px" height="800px" viewBox="0 -64 640 640">
      <path d="M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z" />
    </svg>
  ),
  group: (
    <svg fill="#000000" height="800px" width="800px"
      viewBox="0 0 611.998 611.998">
      <g>
        <g>
          <path d="M382.167,150.945c9.702,10.875,16.557,24.306,20.381,39.921c3.629,14.822,4.44,31.308,2.414,49.006
			c-0.751,6.546-1.861,13.96-3.479,21.802c12.532,12.135,28.95,19.839,50.296,19.838c59.22-0.005,80.529-59.3,86.105-108.006
			c6.872-60.004-21.498-105.163-86.105-105.163c-50.698,0-79.079,27.82-85.628,68.798
			C372.076,141.062,377.449,145.655,382.167,150.945z"/>
          <path d="M611.973,422.704c-0.645-18.899-2.861-37.887-6.161-56.495c-3.992-22.539-9.08-55.585-28.759-70.275
			c-11.38-8.491-26.117-11.278-39.143-16.398c-6.343-2.492-12.024-4.967-17.354-7.784c-17.995,19.734-41.459,30.055-68.782,30.057
			c-21.261,0-40.172-6.281-56.001-18.358c-3.644,11.272-8.522,22.623-15.044,32.994c5.728,3.449,11.923,6.204,19.451,9.162
			c3.332,1.31,6.99,2.506,10.864,3.771c10.472,3.422,22.339,7.301,32.994,15.255c25.329,18.907,31.564,54.336,36.117,80.207
			l0.49,2.792c2.355,13.266,4.084,26.299,5.197,38.961c20.215-2.071,40.327-5.61,60.047-9.774
			c15.941-3.365,31.774-7.471,47.109-13.003C605.247,439.397,612.476,437.343,611.973,422.704z"/>
          <path d="M160.216,281.511c21.345,0.002,37.762-7.703,50.295-19.838c-1.618-7.841-2.728-15.256-3.479-21.802
			c-2.026-17.697-1.214-34.184,2.414-49.006c3.823-15.614,10.679-29.046,20.381-39.921c4.718-5.291,10.09-9.884,16.014-13.805
			c-6.549-40.978-34.93-68.798-85.628-68.798c-64.606,0-92.977,45.16-86.106,105.163
			C79.687,222.212,100.996,281.507,160.216,281.511z"/>
          <path d="M167.957,344.634c10.655-7.954,22.524-11.833,32.994-15.255c3.875-1.265,7.531-2.461,10.864-3.771
			c7.528-2.957,13.725-5.711,19.451-9.162c-6.52-10.369-11.4-21.722-15.043-32.994c-15.829,12.077-34.741,18.358-56.001,18.358
			c-27.322-0.001-50.788-10.324-68.782-30.057c-5.329,2.817-11.012,5.291-17.354,7.784c-13.026,5.12-27.763,7.907-39.143,16.398
			c-19.678,14.691-24.767,47.735-28.759,70.275c-3.3,18.607-5.516,37.595-6.161,56.495c-0.502,14.64,6.726,16.693,18.974,21.112
			c15.334,5.531,31.17,9.637,47.109,13.003c19.72,4.165,39.833,7.704,60.047,9.774c1.112-12.662,2.841-25.693,5.197-38.961
			l0.49-2.792C136.394,398.971,142.628,363.541,167.957,344.634z"/>
          <path d="M470.351,429.405l-0.493-2.805c-4.258-24.197-10.091-57.334-32.191-73.832c-9.321-6.957-19.872-10.404-30.078-13.74
			c-4.019-1.313-7.812-2.554-11.427-3.974c-5.269-2.07-10.016-4.097-14.464-6.338c-18.684,24.932-44.58,38.059-75.383,38.062
			c-30.795,0-56.687-13.128-75.371-38.062c-4.449,2.243-9.196,4.269-14.467,6.34c-3.61,1.418-7.406,2.659-11.424,3.972
			c-10.207,3.335-20.761,6.784-30.079,13.74c-22.107,16.5-27.936,49.645-32.193,73.846l-0.493,2.795
			c-3.557,20.086-5.68,39.572-6.308,57.914c-0.737,21.519,12.62,26.316,24.403,30.55l1.269,0.457
			c14.17,5.112,30.021,9.492,48.457,13.388c37.646,7.946,68.197,11.74,96.138,11.938h0.072h0.072
			c27.946-0.199,58.495-3.992,96.135-11.938c18.439-3.894,34.289-8.274,48.453-13.387l1.268-0.456
			c11.786-4.233,25.147-9.029,24.41-30.553C476.03,468.931,473.906,449.447,470.351,429.405z"/>
          <path d="M221.005,243.009c5.577,48.709,26.883,108.009,86.103,108.006s80.529-59.297,86.106-108.006
			c6.871-60.002-21.503-105.16-86.106-105.16C242.515,137.847,214.123,183.002,221.005,243.009z"/>
        </g>
      </g>
    </svg>
  ),
  suitcase: (
    <svg fill="#000000" version="1.1"
      width="800px" height="800px" viewBox="0 0 594.983 594.983">
      <g>
        <g>
          <rect x="36.534" y="542.792" width="46.971" height="36.533" />
          <rect x="516.695" y="542.792" width="46.972" height="36.533" />
          <path d="M287.052,365.34h31.317c20.875,0,26.097-8.803,26.097-26.096v-52.193h250.518V135.697
			c0-17.293-14.019-31.312-31.316-31.312h-86.115V67.851c0-28.778-23.414-52.192-52.192-52.192H169.625
			c-28.778,0-52.192,23.414-52.192,52.192v36.534H31.317C14.023,104.385,0,118.403,0,135.697v151.355h260.956v52.193
			C260.956,356.538,266.177,365.34,287.052,365.34z M159.187,104.385V67.851c0-5.757,4.686-10.438,10.438-10.438h255.74
			c5.757,0,10.438,4.681,10.438,10.438v36.534H159.187z"/>
          <path d="M594.983,485.377V323.586H375.777v46.971c0,17.293-14.019,31.312-31.312,31.312H255.74
			c-17.294,0-31.312-14.02-31.312-31.312v-46.971H0v161.791c0,17.295,14.019,31.312,31.317,31.312h532.354
			C580.965,516.696,594.983,502.676,594.983,485.377z"/>
        </g>
      </g>
    </svg>
  ),
  email: (
    <svg fill="#000000" height="800px" width="800px" version="1.1"
      viewBox="0 0 75.294 75.294">
      <g>
        <path d="M66.097,12.089h-56.9C4.126,12.089,0,16.215,0,21.286v32.722c0,5.071,4.126,9.197,9.197,9.197h56.9
		c5.071,0,9.197-4.126,9.197-9.197V21.287C75.295,16.215,71.169,12.089,66.097,12.089z M61.603,18.089L37.647,33.523L13.691,18.089
		H61.603z M66.097,57.206h-56.9C7.434,57.206,6,55.771,6,54.009V21.457l29.796,19.16c0.04,0.025,0.083,0.042,0.124,0.065
		c0.043,0.024,0.087,0.047,0.131,0.069c0.231,0.119,0.469,0.215,0.712,0.278c0.025,0.007,0.05,0.01,0.075,0.016
		c0.267,0.063,0.537,0.102,0.807,0.102c0.001,0,0.002,0,0.002,0c0.002,0,0.003,0,0.004,0c0.27,0,0.54-0.038,0.807-0.102
		c0.025-0.006,0.05-0.009,0.075-0.016c0.243-0.063,0.48-0.159,0.712-0.278c0.044-0.022,0.088-0.045,0.131-0.069
		c0.041-0.023,0.084-0.04,0.124-0.065l29.796-19.16v32.551C69.295,55.771,67.86,57.206,66.097,57.206z"/>
      </g>
    </svg>
  ),
  dollar: (
    <svg fill="#000000" version="1.1"
      width="800px" height="800px" viewBox="0 0 31.371 31.371">
      <g>
        <path d="M24.26,20.34c0,3.42-2.423,6.342-6.845,7.111v3.92h-3.768v-3.648c-2.578-0.117-5.076-0.811-6.537-1.654l1.154-4.5
		c1.615,0.886,3.883,1.693,6.383,1.693c2.191,0,3.691-0.848,3.691-2.385c0-1.461-1.23-2.389-4.077-3.348
		c-4.112-1.385-6.921-3.306-6.921-7.033c0-3.386,2.385-6.035,6.499-6.845V0h3.767v3.383c2.576,0.115,4.309,0.652,5.576,1.268
		l-1.115,4.348C21.07,8.575,19.3,7.688,16.531,7.688c-2.5,0-3.307,1.076-3.307,2.154c0,1.268,1.346,2.074,4.613,3.307
		C22.416,14.762,24.26,16.877,24.26,20.34z"/>
      </g>
    </svg>
  ),
  user: (
    <svg height="800px" width="800px" version="1.1"
      viewBox="0 0 60.671 60.671">
      <g>
        <g>
          <ellipse cx="30.336" cy="12.097" rx="11.997" ry="12.097" />
          <path d="M35.64,30.079H25.031c-7.021,0-12.714,5.739-12.714,12.821v17.771h36.037V42.9
			C48.354,35.818,42.661,30.079,35.64,30.079z"/>
        </g>
      </g>
    </svg>
  ),
  password2: (
    <svg fill="#000000" version="1.1" width="800px" height="800px" viewBox="0 0 47 47">
      <g>
        <g>
          <path d="M37.076,19.748c-0.824,0-1.494,0.672-1.494,1.499v1.46h2.991v-1.46C38.573,20.42,37.9,19.748,37.076,19.748z" />
          <path d="M41.227,12.635H5.773C2.6,12.635,0,15.237,0,18.41v10.18c0,3.178,2.6,5.775,5.773,5.775h35.454
			C44.4,34.365,47,31.768,47,28.59V18.41C47,15.237,44.4,12.635,41.227,12.635z M12.56,25.077l1.385,1.508l-2.399,1.8l-0.984-1.8
			c-0.145-0.257-0.372-0.761-0.691-1.508c-0.349,0.821-0.581,1.321-0.696,1.508l-0.998,1.8l-2.466-1.8l1.491-1.508
			c0.42-0.415,0.827-0.771,1.229-1.063c-0.41-0.037-0.949-0.113-1.614-0.238l-2.065-0.336l0.958-2.812l1.852,0.842
			c0.195,0.088,0.68,0.365,1.452,0.824c-0.165-0.747-0.271-1.302-0.319-1.666l-0.263-2.013h2.941l-0.238,2.013
			c-0.052,0.49-0.166,1.045-0.335,1.666c0.339-0.17,0.563-0.283,0.669-0.345c0.372-0.207,0.659-0.35,0.852-0.442l1.853-0.879
			l0.918,2.812l-2.049,0.428c-0.375,0.072-0.931,0.119-1.67,0.146C11.874,24.406,12.266,24.758,12.56,25.077z M26.137,25.077
			l1.387,1.508l-2.399,1.799l-0.983-1.799c-0.145-0.257-0.372-0.761-0.69-1.508c-0.35,0.821-0.58,1.321-0.695,1.508l-1,1.799
			l-2.465-1.799l1.491-1.508c0.42-0.415,0.826-0.771,1.229-1.063c-0.408-0.037-0.949-0.113-1.614-0.238l-2.066-0.336l0.959-2.812
			l1.853,0.842c0.193,0.088,0.68,0.365,1.451,0.824c-0.169-0.747-0.275-1.302-0.32-1.666l-0.264-2.011h2.942l-0.239,2.011
			c-0.054,0.49-0.166,1.045-0.333,1.666c0.337-0.17,0.561-0.283,0.668-0.345c0.37-0.207,0.658-0.35,0.852-0.442l1.854-0.879
			l0.919,2.812l-2.051,0.428c-0.375,0.072-0.929,0.119-1.669,0.146C25.451,24.406,25.844,24.758,26.137,25.077z M41.35,27.625
			c0,0.619-0.507,1.125-1.125,1.125H33.93c-0.619,0-1.125-0.506-1.125-1.125v-3.794c0-0.619,0.506-1.125,1.125-1.125h0.152v-1.46
			c0-1.653,1.343-2.998,2.994-2.998c1.652,0,2.996,1.344,2.996,2.998v1.46h0.152c0.617,0,1.125,0.506,1.125,1.125V27.625z"/>
        </g>
      </g>
    </svg>
  ),
  idCard: (
    <svg fill="#000000" height="800px" width="800px" version="1.1"
      viewBox="0 0 260.666 260.666">
      <g>
        <path d="M236.666,40.882H24c-13.233,0-24,10.767-24,24v130.902c0,13.233,10.767,24,24,24h212.666c13.233,0,24-10.767,24-24V64.882
		C260.666,51.648,249.899,40.882,236.666,40.882z M245.666,195.784c0,4.962-4.037,9-9,9H24c-4.963,0-9-4.038-9-9V64.882
		c0-4.962,4.037-9,9-9h212.666c4.963,0,9,4.038,9,9V195.784z"/>
        <path d="M216.04,83.703h-68.933c-3.314,0-6,2.687-6,6s2.686,6,6,6h68.933c3.314,0,6-2.687,6-6S219.354,83.703,216.04,83.703z" />
        <path d="M216.04,164.963h-68.933c-3.314,0-6,2.686-6,6c0,3.313,2.686,6,6,6h68.933c3.314,0,6-2.687,6-6
		C222.04,167.649,219.354,164.963,216.04,164.963z"/>
        <path d="M216.04,118.411h-41.718c-3.313,0-6,2.687-6,6s2.687,6,6,6h41.718c3.314,0,6-2.687,6-6S219.354,118.411,216.04,118.411z" />
        <path d="M216.04,141.686h-41.718c-3.313,0-6,2.687-6,6c0,3.314,2.687,6,6,6h41.718c3.314,0,6-2.686,6-6
		C222.04,144.373,219.354,141.686,216.04,141.686z"/>
        <path d="M85.163,133.136c17.004,0,30.838-13.839,30.838-30.849c0-17.011-13.834-30.85-30.838-30.85
		c-17.009,0-30.847,13.839-30.847,30.85C54.316,119.297,68.154,133.136,85.163,133.136z M85.163,86.438
		c8.733,0,15.838,7.11,15.838,15.85c0,8.739-7.104,15.849-15.838,15.849c-8.738,0-15.847-7.11-15.847-15.849
		C69.316,93.548,76.425,86.438,85.163,86.438z"/>
        <path d="M97.097,138.68H73.415c-16.592,0-30.09,13.497-30.09,30.088v12.961c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-12.961
		c0-8.319,6.77-15.088,15.09-15.088h23.682c8.32,0,15.09,6.768,15.09,15.088v12.961c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5
		v-12.961C127.187,152.177,113.688,138.68,97.097,138.68z"/>
      </g>
    </svg>
  ),
  refresh: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#111"
      style={{
        animation: 'rotate 2s linear infinite',
        transformOrigin: 'center'
      }}
    >
      <style jsx>{`
                @keyframes rotate {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(-360deg); }
                }
            `}</style>
      <path d="M160-160v-80h110l-16-14q-52-46-73-105t-21-119q0-111 66.5-197.5T400-790v84q-72 26-116 88.5T240-478q0 45 17 87.5t53 78.5l10 10v-98h80v240H160Zm400-10v-84q72-26 116-88.5T720-482q0-45-17-87.5T650-648l-10-10v98h-80v-240h240v80H690l16 14q49 49 71.5 106.5T800-482q0 111-66.5 197.5T560-170Z" />
    </svg>
  )

};

export function getProfileIcon(type) {
  return profileIcons[type];
}
